<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <h5 class="border-bottom pb-2 mb-2">{{ 'listofdgc.List of DGCs' | translate}}</h5>
      </div>

      <div class="col-md-12 d-flex justify-content-start mt-4 px-3">

        <div class="form-group">
          <label class="w-100">{{ 'header.state' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="selectedstate" class="form-control custom-selectbox w-100">
            <option value="undefined" disabled>{{ 'tabledataforstates.selectstate' | translate }}</option>
            <option value="f78f615d-e270-4f93-90ac-27608e756b85">{{ 'tabledataforstates.all' | translate }}</option>
            <option *ngFor="let state of statelists" value="{{state['uuid']}}">{{ 'tabledataforstates.' + state['name'] | translate }}</option>
          </select>
        </div>&nbsp;&nbsp;

        <div class="form-group">
          <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
          <button class="btn btn-info pointer" (click)="getListofDGCs()" type="submit">{{ 'themeandassessment.view' | translate}}</button>
        </div>
        <div class="form-group">
          <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
          <button class="btn btn-info pointer" (click)="printListofDGCs()" type="submit">{{ 'listofdgc.print' | translate }}</button>
        </div>
      </div>
    </div>

    <div class="table-responsive" id="content">
      <table class="table table-sm w-50" *ngIf="dgcList">
        <thead>
          <tr class="text-center  ">
            <th scope="col">{{'trigManage.sno' | translate}}</th>
            <th scope="col">{{ 'header.state' | translate }}</th>
            <th scope="col">{{ 'listofdgc.District Ganga Committee Name' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let dgc of dgcList| keyvalue;let k=index" >
          <ng-container *ngIf="k==0">{{initializeSno()}}</ng-container>
          <tr *ngFor="let item of dgc.value;let j = index">
            <td>{{getSno()}}</td>
            <td>{{ 'tabledataforstates.' + formatState(dgc.key) | translate}}</td>
            <td>{{ 'districtsdata.' + item | translate }}</td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>